/* eslint-disable import/extensions,react/no-unused-prop-types,jsx-a11y/no-static-element-interactions,arrow-body-style */
import React, {
  Component,
  PropTypes,
} from 'react';
import DateTimePickerMinutes from './DateTimePickerMinutes';
import DateTimePickerHours from './DateTimePickerHours';
import Constants from './Constants.js';
import Icon from '../Icon/index';

export default class DateTimePickerTime extends Component {
  static propTypes = {
    setSelectedHour: PropTypes.func.isRequired,
    setSelectedMinute: PropTypes.func.isRequired,
    subtractHour: PropTypes.func.isRequired,
    addHour: PropTypes.func.isRequired,
    subtractMinute: PropTypes.func.isRequired,
    addMinute: PropTypes.func.isRequired,
    viewDate: PropTypes.object.isRequired,
    selectedDate: PropTypes.object.isRequired,
    togglePeriod: PropTypes.func.isRequired,
    mode: PropTypes.oneOf([Constants.MODE_DATE, Constants.MODE_DATETIME, Constants.MODE_TIME]),
    changeMinute: PropTypes.func.isRequired,
    changeHour: PropTypes.func.isRequired,
  };

  state = {
    minutesDisplayed: false,
    hoursDisplayed: false,
  };

  goBack = () => {
    return this.setState({
      minutesDisplayed: false,
      hoursDisplayed: false,
    });
  };

  showMinutes = () => {
    return this.setState({
      minutesDisplayed: true,
    });
  };

  showHours = () => {
    return this.setState({
      hoursDisplayed: true,
    });
  };

  renderMinutes = () => {
    if (this.state.minutesDisplayed) {
      return <DateTimePickerMinutes {...this.props} onSwitch={this.goBack} />;
    }
    return null;
  };

  renderHours = () => {
    if (this.state.hoursDisplayed) {
      return <DateTimePickerHours {...this.props} onSwitch={this.goBack} />;
    }
    return null;
  };

  renderPicker = () => {
    if (!this.state.minutesDisplayed && !this.state.hoursDisplayed) {
      return (
        <div className="timepicker-picker">
          <div className="row justify-content-between">
            <div className="col-4">
              <div className="row">
                <div className="col-12 text-center">
                  <a className="btn-up-down" onClick={this.props.addHour}>
                    <Icon name="fa-chevron-up" />
                  </a>
                </div>
                <div className="col-12 text-center">
                  <input
                    className="time-input"
                    type="number"
                    style={{ width: '100%', textAlign: 'center' }}
                    value={this.props.selectedDate.format('h')}
                    onChange={this.props.changeHour}
                  />
                </div>
                <div className="col-12 text-center">
                  <a className="btn-up-down" onClick={this.props.subtractHour}>
                    <Icon name="fa-chevron-down" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="row">
                <div className="col-12 text-center">
                  <a className="btn-up-down" onClick={this.props.addMinute}>
                    <Icon name="fa-chevron-up" />
                  </a>
                </div>
                <div className="col-12 text-center">
                  <input
                    className="time-input"
                    type="number"
                    value={this.props.selectedDate.format('mm')}
                    onChange={this.props.changeMinute}
                  />
                </div>
                <div className="col-12 text-center">
                  <a className="btn-up-down" onClick={this.props.subtractMinute}>
                    <Icon name="fa-chevron-down" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-4 align-items-center justify-content-center" style={{ display: 'flex' }}>
              <div className="row">
                <div className="col-12 text-center">
                  <a className="btn-up-down" onClick={this.props.togglePeriod}>
                    <Icon name="fa-chevron-up" />
                  </a>
                </div>
                <div className="col-12">
                  <button
                    className="btn-time"
                    type="button"
                  >
                    {this.props.selectedDate.format('A')}
                  </button>
                </div>
                <div className="col-12 text-center">
                  <a className="btn-up-down" onClick={this.props.togglePeriod}>
                    <Icon name="fa-chevron-down" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return '';
  };

  render() {
    return (
      <div className="timepicker">
        {this.renderPicker()}

        {this.renderHours()}

        {this.renderMinutes()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/TimePicker/DateTimePickerTime.js